<div class="nudjene-cijene-container">
  <!-- Filters Section -->
  <div class="filters-section">
    <div class="filter-row">
      <!-- Date Range Picker -->
      <div class="filter-group">
        <label class="filter-label">Raspon datuma</label>
        <dx-date-range-box displayFormat="dd.MM.yyyy" [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChange($event)"
          (endDateChange)="onEndDateChange($event)" placeholder="Odaberite raspon datuma..." class="filter-control">
        </dx-date-range-box>
      </div>

      <!-- Execute Button -->
      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button text="Učitaj podatke" icon="search" type="default" stylingMode="contained" (onClick)="loadData()"
          [disabled]="!isFormValid()" class="execute-btn">
        </dx-button>
      </div>

      <!-- Create Nudjene Cijene Button -->
      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button [visible]="isUserModerator" text="Kreiraj nudjene cijene" icon="plus" type="default" stylingMode="contained"
          (onClick)="showCreateNudjeneCijene()" class="execute-btn">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="grid-section">
    <dx-data-grid #nudjeneCijeneGrid id="nudjeneCijeneGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
      [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
      [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true">

      <!-- Columns Definition -->
      <dxi-column type="buttons" width="120" caption="Opcije" [visible]="isUserModerator">
        <dxi-button name="delete" icon="trash" hint="Izbriši" [visible]="true" [onClick]="onDeleteClick"></dxi-button>
      </dxi-column>

      <dxi-column dataField="datum" caption="Datum" dataType="date" format="dd.MM.yyyy"></dxi-column>
      <dxi-column dataField="tekst" caption="Tekst"></dxi-column>

    </dx-data-grid>
  </div>

  <!-- Create Nudjene Cijene Popup -->
  <app-create-nudjene-cijene 
    [visible]="createNudjeneCijenePopupVisible" 
    (visibleChange)="createNudjeneCijenePopupVisible = $event"
    (nudjeneCijeneCreated)="onNudjeneCijeneCreated($event)">
  </app-create-nudjene-cijene>

  <!-- Loading Overlay -->
  <dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
    [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>